import { XLSXFormatter } from './excel-formatter';
import { IdsZip } from './zip';

import {
  CONTENT_TYPES,
  RELS,
  STYLES_XML, WORKBOOK_XML,
  WORKBOOK_XML_REL
} from './worksheet-templates';
import { saveAs } from './file-saver';

const DEFAULT_FILENAME = 'DataGrid (Export)';

/**
 * Export to XLSX format
 * @param {Array<Record<string, any>>} data excel data
 * @param {ExcelConfig} config excel config
 */
export function exportToXLSX(data, config) {
  // create mostly static xlsx files
  const root = new IdsZip();
  root.file('xl/workbook.xml', WORKBOOK_XML);
  root.file('xl/_rels/workbook.xml.rels', WORKBOOK_XML_REL);
  root.file('xl/styles.xml', STYLES_XML);
  root.file('_rels/.rels', RELS);
  root.file('[Content_Types].xml', CONTENT_TYPES);

  // generate xlsx worksheet data
  const xlsxFormatter = new XLSXFormatter();
  root.file('xl/worksheets/sheet1.xml', xlsxFormatter.generateWorksheet(data, config.columns));
  const zipFile = root.zip('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

  // download
  const filename = `${config.filename || DEFAULT_FILENAME}.xlsx`;
  saveAs(filename, zipFile);
}
